/** @format */

import React, { useEffect } from 'react';
import { Grid, Button, Box, Typography } from '@mui/material';
import {
  UploadMedia,
  PageContainer,
  InputV2,
  PickList,
  ButtonLoading,
  ConfirmDialog,
  LoadingPage,
  Icons
} from 'components';
import useCustomHook from '../hooks';

import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { makeStyles } from '@mui/styles';
import {
  getServiceCallApi,
  addServiceSetApi,
  getServiceSetDetailsApi,
  updateServiceSetApi,
} from '../services/ServiceSetServices';
import { WebServiceAutoComplete } from './components';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';

const useStyles = makeStyles((theme) => ({
  containButton: {
    '& > *': {
      margin: `5px 10px`,
    },
  },
  submitContainer: {
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.grey[300]}`,
  },
  curve: {
    borderRadius: '50%',
  },
  inputStatusIcon: {
    fontSize: 15,
    marginBottom: theme.spacing(-0.5),
    marginInlineEnd: theme.spacing(0.5),
  },
}));

const CreateServiceSet = (props) => {
  const classes = useStyles();
  const {
    loadingPage,
    setLoadingPage,
    loadingBtn,
    setLoadingBtn,
    openSnack,
    setOpenSnack,
    webServicesSearch,
    setWebServicesSearch,
    webServicesList,
    setWebServicesList,
    images,
    setImages,
    imageData,
    setImageData,
    openDialog,
    setOpenDialog,
    editPage,
    setEditPage,
    selectedForRemove,
    setSelectedForRemove,
  } = useCustomHook();
  const actionsList =
    getDynamicObjectAction([
      'newSetWebServiceDefinePage',
      'editSubMyWebServiceListPage'
    ])
  const navigate = useNavigate();
  const paramsId = useParams();
  const { control, handleSubmit, formState: { errors }, register, reset } = useForm();
  useEffect(() => {
    if (actionsList['newSetWebServiceDefinePage'] || actionsList['editSubMyWebServiceListPage']) {
      (async () => {
        try {
          setLoadingPage(true);
          const params = {
            offset: 0,
            size: 10,
          };

          const resServiceCall = await getServiceCallApi(params);

          if (paramsId?.id) {
            setEditPage(true);
            const resServiceSet = await getServiceSetDetailsApi(paramsId?.id);

            reset({
              serviceSetName: resServiceSet.result.name,
              description: resServiceSet.result.descriptionSituation,
            });

            if (resServiceSet.result?.webservices && resServiceSet.result.webservices.length) {
              const serviceCall = resServiceSet.result.webservices.map((item) => ({
                value: item.id,
                label: item.name,
                new: false,
              }));

              setWebServicesList(serviceCall);
            }

            if (resServiceSet.result?.image && resServiceSet.result.image.name) {
              const imageDetails = resServiceSet.result.image;
              setImageData((prevState) => ({
                ...prevState,
                src: imageDetails.hashCode ?? `${process.env?.REACT_APP_BASE_URL_UPLOAD_PODSAPCE + imageDetails.hashCode}`,
                formServer: imageDetails,
              }));

              setImages({ logo: `${process.env?.REACT_APP_BASE_URL_UPLOAD_PODSAPCE + imageDetails.hashCode}` });
            }
          }

          if (resServiceCall.result.length > 0) {
            const list = resServiceCall.result.map((item) => ({
              value: item.id,
              label: item.name,
            }));

            setWebServicesSearch(list);
          }
          setLoadingPage(false);
        } catch (error) {
          setLoadingPage(false);

          setOpenSnack(true);
        }
      })();
    }

  }, [paramsId]);

  const onSubmit = (data) => {
    setLoadingBtn(true);

    let dataApi = {};

    let image = {
      name: '',
      hash: '',
      // id: ''
    };

    if (imageData.uploadDetails.hasOwnProperty('hash')) {
      image = { ...imageData.uploadDetails };
    } else if (imageData?.formServer && !imageData.removed) {
      image = imageData.formServer;
    }

    image.hashCode = image.hash;

    let services = [];
    if (webServicesList.length) {
      services = webServicesList.map((item) => ({
        name: item.label,
        id: +item.value,
      }));
    }

    dataApi = {
      name: data.serviceSetName,
      descriptionSituation: data.description,
      status: 'draft',
      image,
      webservices: services,
    };

    if (editPage) {
      dataApi.id = paramsId?.id;
      delete dataApi.status;
    }

    async function addOrUpdateServiceSet(params) {
      let txt = { txt: '', action: '' };
      let successful = false;
      try {
        if (editPage) {
          await updateServiceSetApi(params);
        } else {
          await addServiceSetApi(params);
        }
        txt = {
          txt: 'با موفقیت ثبت شد.',
          action: 'success',
        };
        successful = true;
      } catch (error) {
        txt = {
          txt: error?.response?.data?.message || 'خطا در ارسال داده، لطفا مجداد تلاش نمایید.',
          action: 'error',
        };
      }

      setOpenSnack(true);
      setLoadingBtn(false);

      if (successful) {
        navigate('/services/service-set');
      }
    }
    addOrUpdateServiceSet(dataApi);
  };

  const selectServiceCallFunc = (newVal) => {
    const index = webServicesList.findIndex((val) => val.value === newVal[0].value);
    if (index === -1) {
      setWebServicesList((prev) => [...prev, ...newVal]);
    }
  };

  const removeItem = async (item, indexRow) => {
    setOpenDialog(true);
    setSelectedForRemove({ ...item, indexRow });
  };

  const confirmDelete = () => {
    webServicesList.splice(selectedForRemove.indexRow, 1);
    setWebServicesList([...webServicesList]);
    setOpenDialog(false);
  };

  const closeDialog = () => {
    setOpenDialog(false);
  };

  const hintText =
    'در این قسمت، مجموعه سرویس‌هایی که تعریف می‌شود، پس از تایید ادمین‌های پادیوم، در بازارچه پادیوم قرار خواهند گرفت.';

  return (
    <PageContainer
      title="تعریف مجموعه سرویس"
      description={hintText}
      breadcrumbs={constBreadCrumbsTitle.SERVICES_SERVICESET_CREATE}
    >
      {(actionsList['newSetWebServiceDefinePage'] || actionsList['editSubMyWebServiceListPage']) && (
        <>
          {
            loadingPage ? (
              <LoadingPage />
            ) : (
              <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
                <Typography style={{ fontSize: 13, fontWeight: 'bold', paddingBottom: 8 }}>
                  <span className={classes.inputStatusIcon}>
                    <Icons icon='Info' color='#667585' hover='#667585' size='20' />
                  </span>
                  توجه: تا زمانی که گزینه "ذخیره" فرم را انتخاب نکنید، تغییرات تمامی فیلدها و تغییرات
                  تصویر اعمال نخواهد شد.
                </Typography>
                <Grid container spacing={3}>
                  <Grid direction="row" container item xs={6}>
                    <Grid item xs={12}>
                      <InputV2
                        fullWidth
                        errors={errors}
                        label="نام مجموعه سرویس"
                        name="serviceSetName"
                        register={register}
                        rules={['required']}
                        control={control}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <InputV2
                        label="توضیحات"
                        multiline
                        fullWidth
                        rows={5}
                        errors={errors}
                        name="description"
                        register={register}
                        control={control}
                      />
                    </Grid>

                    {webServicesSearch.length > 0 && (
                      <Grid item xs={12}>
                        <WebServiceAutoComplete
                          control={control}
                          // errors={errors}
                          register={register}
                          name="service"
                          label="جستجوی سرویس ها"
                          labelTextField="نام یک وب سرویس را وارد نمایید."
                          tooltip="در این قسمت لیست سرویس‌هایی که می‌خواهید زیر مجموعه این مجموعه سرویس قرار گیرند را جستجو و انتخاب کنید."
                          preventAddCustomOption
                          list={webServicesSearch}
                          defaultValue={[]}
                          // required={true}
                          multiple
                          onChangeValue={selectServiceCallFunc}
                          setWebServices={setWebServicesSearch}
                        />
                      </Grid>
                    )}

                    {webServicesList.length > 0 && (
                      <Grid item xs={12}>
                        <Box mt={2}>
                          <PickList
                            // loading={inquiryServiceCall}
                            items={webServicesList}
                            onRemove={removeItem}
                            title="نام سرویس"
                            labelKey="label"
                            selectedRow={selectedForRemove}
                          />
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                  <Grid
                    direction="row"
                    container
                    alignContent="flex-start"
                    justifyContent="flex-end"
                    item
                    xs={6}
                  >
                    <Grid item>
                      <UploadMedia
                        round
                        name="image"
                        ratio="1:1"
                        alt="تصویر مجموعه سرویس"
                        placholder="تصویر مجموعه سرویس"
                        onChange={(url) => setImages({ logo: url })}
                        value={images?.logo}
                        setImageData={setImageData}
                      />
                    </Grid>
                  </Grid>
                  {/* </Grid> */}
                  <Grid direction="row" container item xs={12} className={classes.submitContainer} justifyContent='flex-end'>
                    <div className={classes.containButton}>
                      <ButtonLoading
                        type="submit"
                        variant="contained"
                        color="primary"
                        loading={loadingBtn}
                        name="ذخیره"
                      />

                      <Button variant="contained" onClick={() => navigate('/services/service-set')}>
                        انصراف
                      </Button>

                    </div>
                  </Grid>
                </Grid>
              </form>
            )}
        </>
      )}

      <ConfirmDialog
        open={openDialog}
        onClose={closeDialog}
        onConfirm={confirmDelete}
        title="حذف وب سرویس از مجموعه"
        content={`آیا از حذف سرویس  "<b>${selectedForRemove.label}</b>" از مجموعه سرویس اطمینان دارید؟`}
        confirmButtonText="تایید"
        cancelButtonText="انصراف"
      />
    </PageContainer>
  );
};
export default CreateServiceSet;

